import { useMutation } from '@tanstack/react-query'

import { updateSteeringDefaults } from '@/features/resource/endpoints/resources'
import type { ResourceSteeringDefaultsSchemaType } from '@/features/resource/types'
import { convertToWatts } from '@/features/resource/utils/convertToWatts'

export function useUpdateSteeringDefaultsMutation(resourceID: string) {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (data: ResourceSteeringDefaultsSchemaType) => {
      const defaultConsumptionLevel =
        data.steeringDefaultType === 'SET_TO_DEFAULT_LEVEL' && data.defaultConsumptionLevel !== null
          ? convertToWatts(data.defaultConsumptionLevel)
          : null

      return updateSteeringDefaults(resourceID, data.steeringDefaultType, defaultConsumptionLevel)
    },
  })

  return {
    updateSteeringDefaults: mutateAsync,
    ...mutationResult,
  }
}
